var getCategoryMeta = category => {
  var title = category.metaTitle || category.name;
  var description = category.metaDescription || category.description;
  var meta = {
    title,
    data: [{
      property: "og:title",
      content: title
    }]
  };

  if (description) {
    meta.data.push({
      name: "description",
      content: description
    }, {
      property: "og:description",
      content: description
    });
  }

  return meta;
};

export { getCategoryMeta };
//# sourceMappingURL=get-meta.js.map
